import gql from "graphql-tag";

export const ME = gql`
  query {
    me {
      id
      isSuperAdmin
      profile {
        role {
          permissions
        }
      }
    }
  }
`;

export const CHANAGE_LANGAGE = gql`
  mutation updateCurrentLangage($langage: LangageInput) {
    updateCurrentLangage(langage: $langage) {
      id
    }
  }
`;

export const ACTIVE_USER = gql`
  mutation activeUser($userId: ID) {
    activeUser(userId: $userId)
  }
`;

export const ADD_STORE_MUTATION = gql`
  mutation addStore($input: StoreInput) {
    addStore(input: $input) {
      id
    }
  }
`;

export const UPDATE_STORE_MUTATION = gql`
  mutation updateStore($input: StoreInputUpdate) {
    updateStore(input: $input) {
      id
    }
  }
`;
export const UPDATE_MY_PROFILE = gql`
  mutation updateMyStore($input: StoreInput) {
    updateMyStore(input: $input) {
      id
    }
  }
`;
export const UPDATE_MY_SETTING = gql`
  mutation updateMyStoreSettings($input: StoreInput) {
    updateMyStoreSettings(input: $input) {
      id
    }
  }
`;

export const STORE_FRAGMENT = gql`
  fragment planing on Florist {
    name
    appearsIn
    friends {
      name
    }
  }
`;

export const GET_STORE = gql`
  query getFlorist($id: ID) {
    getFlorist(id: $id) {
      id
      name
      gerantName
      gerantEmail
      gerantTel
      webSite
      address
      tel
      siret
      description
      photoUrl
      storeCountry {
        id
      }
      closedDay {
        key
        startDay
        endDay
      }
      planing {
        monday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        tuesday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        wednesday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        thursday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        friday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        saturday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        sunday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
      }

      settings {
        stuartDeliver
        iDeliver
        nbKlm
        nbMaxCommands
        timeSlot
        nbKgMax
        iDrive
      }
      planingDrive {
        monday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        tuesday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        wednesday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        thursday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        friday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        saturday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        sunday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
      }

      location {
        latitude
        longitude
      }
      profile {
        email
      }
    }
  }
`;

export const MY_PROFILe = gql`
  query {
    myStore {
      id
      name
      gerantName
      gerantEmail
      gerantTel
      webSite
      address
      tel
      siret
      description
      photoUrl
      closedDay {
        key
        startDay
        endDay
      }
      planing {
        monday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        tuesday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        wednesday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        thursday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        friday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        saturday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
        sunday {
          firstSession {
            openAt
            closeAt
            work
          }
          secondSession {
            openAt
            closeAt
            work
          }
        }
      }
      location {
        latitude
        longitude
      }
      profile {
        email
      }
    }
  }
`;
